<template>
  <div class="dialog-wrapper">
    <el-dialog
      :visible="dialogData.visible"
      :width="dialogData.width"
      :before-close="dialogClose"
    >
      <div slot="title" class="dialogTitle">{{ dialogData.title }}</div>
      <div
        class="dialog-content"
        v-loading="dialogData.isLoading"
        :element-loading-text="dialogData.loading_text"
        element-loading-spinner="el-icon-loading"
      >
        <div class="refundInfo">
          <el-form
            ref="refundRef"
            :label-position="labelPosition"
            label-width="180px"
            :model="form"
            :rules="refundRule"
          >
            <el-form-item label="退款公司：">
              <span>{{ deliverData.company_name }}</span>
            </el-form-item>
            <el-form-item label="收款公司：">
              <span>{{ deliverData.payer_card_name }}</span>
            </el-form-item>
            <el-form-item label="退款金额(含服务费)：">
              <span>{{ deliverData.money }}</span>
            </el-form-item>
            <el-form-item label="税费：">
              <span>{{ deliverData.tax_money }}</span>
            </el-form-item>

            <el-form-item label="收款银行账户 :" prop="bank_account_no">
              <span>{{ deliverData.bank_account_no }}</span>
            </el-form-item>
            <el-form-item label="收款支行名称 :" prop="bank_branch">
              <el-input v-model="form.bank_branch"></el-input>
            </el-form-item>
            <el-form-item label="联行号 :" prop="bank_line_no">
              <el-select
                v-model="form.bank_line_no"
                placeholder="选择联行号"
                @change="changeBankHandle"
                clearable
                filterable
              >
                <el-option
                  v-for="item in allBankLineNo"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <div class="faqi-refund-btn">
              <el-button type="primary" @click="refundHandle"
                >确定驳回</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  props: {
    dialogData: {
      type: Object,
      default() {
        return {};
      },
    },
    deliverData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      companyId: "",
      noClick: false,
      selectedBankLine: {},
      userPhone: "",
      radio: "",
      allBankLineNo: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      labelPosition: "right",
      //   表达内容
      form: {
        bank_branch: "",
        bank_line_no: "",
      },
      accountPhone: "",
      refundRule: {
        bank_branch: [{ required: true, message: "收款支行名称不能为空" }],
        bank_line_no: [{ required: true, message: "联行号不能为空" }],
      },
    };
  },
  methods: {
    dialogConfirm() {
      this.$emit('confirm');
    },
    dialogClose() {
      this.dialogData.visible = false;
      this.$refs.refundRef.resetFields();
    },
    //  选择联行号时
    changeBankHandle(value) {
      this.selectedBankLine = this.allBankLineNo.find((item) => {
        return item.id === value;
      });
      console.log(this.selectedBankLine);
    },
    async getAllBankLine() {
      const getBankLinkNoList = await this.$api.getBankCode();
      this.allBankLineNo = getBankLinkNoList;
    },
    // 退款申请
    async refundHandle() {
      this.$refs.refundRef.validate(async (valid) => {
        this.form.bank_branch = this.form.bank_branch.trim();
        if (valid) {
          this.noClick = true;
          let param = {
            company_id: this.deliverData.company_id,
            company_name: this.deliverData.payer_card_name,
            bank_account_no: this.deliverData.bank_account_no,
            bank_line_no: this.selectedBankLine.id,
            bank_branch: this.form.bank_branch,
            bank_name: this.selectedBankLine.name, // 总行名称
            money: this.deliverData.money, // 退款金额
            tax: this.deliverData.tax_money,
            channel_account: this.deliverData.channel_account,
            recharge_order_id:this.deliverData.id
          }
          const result = await this.$api.postRechargeRefuse(param);
          if (result) {
            this.$message.success("发起退款成功");
            this.noClick = false;
            this.dialogConfirm();
            this.dialogClose();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },
  },
  computed: {
  },
  watch: {
    deliverData: {
      handler: function(newVal) {
        this.deliverData = newVal;
      //   this.form = {
      //   bank_account_no: newVal.bank_account_no,
      //   bank_branch: newVal.bank_branch,
      //   bank_line_no: newVal.bank_line_no,
      // }
      },
      deep: true,
    },
  },
  mounted() {
    this.getAllBankLine();
  },
};
</script>
<style scoped lang="scss">
.disabledClick {
  display: flex;
  background: gainsboro !important;
  border: none !important;
}
/deep/ .el-input-group__append {
  background: inherit;
  color: inherit;
}

.el-form-item__label {
  color: black !important;
  font-size: 16px !important;
}
.dialogTitle {
  position: relative;
  padding-left: 10px;
  font-size: 16px;
  color: black;
}
.dialogTitle:before {
  position: absolute;
  width: 4px;
  height: 20px;
  content: "";
  background: #1890ff;
  left: 0;
  top: 0;
}
/deep/ .el-dialog {
  border-radius: 10px;
}
.faqi-refund-btn {
  margin: 20px 0 0 0;
  text-align: center;
}
</style>
